export var PermissionActionCategory;
(function (PermissionActionCategory) {
    PermissionActionCategory["PERMISSION_ACTION_CATEGORY_VIEWING"] = "VIEWING";
    PermissionActionCategory["PERMISSION_ACTION_CATEGORY_OPERATION"] = "OPERATION";
    PermissionActionCategory["PERMISSION_ACTION_CATEGORY_ADMINISTRATION"] = "ADMINISTRATION";
})(PermissionActionCategory || (PermissionActionCategory = {}));
